const messages = {
  title: 'Gateway Timeout Error',
  description: 'We are very sorry for inconvenience. It looks like some how our server did not receive a timely response.',
  backHomeButton: 'Back To Dashboard'
}

export default {
  messages
}
